import { LabelService } from "@/services/label.service";
const state = {
  labels: [],
};

const getters = {
  getLabels(state) {
    return state.labels;
  },
};

const mutations = {
  setLabels(state, value) {
    state.labels = value;
  },
};

const actions = {
  fetchLabels({ commit }) {
    return new Promise((resolve) => {
      LabelService.GetLabels().then((r) => {
        resolve(r.data.result);
        commit("setLabels", r.data.result.data);
      });
    });
  },

  // eslint-disable-next-line no-unused-vars
  addLabel({ commit }, value) {
    return new Promise((resolve, reject) => {
      LabelService.AddLabel(value)
        .then((r) => {
          resolve(r.data);
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateLabel({ commit }, value) {
    return new Promise((resolve, reject) => {
      LabelService.UpdateLabel(value)
        .then((r) => {
          resolve(r.data);
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteLabel({ commit }, id) {
    return new Promise((resolve) => {
      LabelService.DeleteLabel(id).then((r) => {
        resolve(r.data);
      });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
